import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0072',
    ecrans: ['00-2'],
    params: [ 'id', '?daccleint', '?indfor']
});

